<template>
  <BaseLayoutLogin>
    <!-- LOGIN -->
    <form v-if="form.login" class="form-login" @submit="login">
      <!-- USUÁRIO -->
      <FormInput
        v-model="user"
        :class="{ 'form-error': error }"
        name="user"
        label="Usuário"
        placeholder="Insira seu usuário"
        class="form-login--user"
      />
      <!-- SENHA -->
      <FormInput
        v-model="password"
        :class="{ 'form-error': error }"
        name="password"
        label="Senha"
        placeholder="Insira sua senha"
        type="password"
        class="form-login--password"
      />
      <!-- BOTÃO DE ESQUECEU A SENHA -->
      <PmwParagraph
        size="paragraph-40"
        fontSize="small"
        class="form-login--forgot-password"
      >
        <span class="link" @click="toggleForgetPassword()">
          Esqueceu a senha?
        </span>
      </PmwParagraph>
      <!-- FEEDBACK DE ERRO -->
      <div class="form-login--feedback">
        <PmwParagraph v-if="error" size="paragraph-40" fontSize="small">
          <span>{{ message }}</span>
        </PmwParagraph>
      </div>
      <PmwButton :disabled="loading" class="form-login--button" type="submit">
        Fazer login
      </PmwButton>

      <Transition name="fade" appear>
        <!-- BOTÃO SSO MICROSOFT -->
        <button
          v-if="sso.microsoft.enabled"
          :disabled="loading"
          class="form-login--sso-button"
          type="button"
          @click="loginSSO"
        >
          <img
            src="/admin/v2/ms-symbollockup_mssymbol_19.svg"
            alt="Microsoft"
            class="form-login--sso-button__icon"
          />

          Entrar com Microsoft
        </button>
      </Transition>
    </form>
    <!-- ESQUECEU A SENHA -->
    <form
      v-if="form.forgotPassword"
      class="form-forgot-password"
      @submit="forgotPassword"
    >
      <!-- USUÁRIO -->
      <FormInput
        v-model="user"
        :class="{ 'form-error': error }"
        label="Usuário"
        placeholder="Insira seu usuário"
        class="form-login--user"
      />
      <!-- MENSAGEM -->
      <PmwParagraph fontSize="small" class="form-forgot-password--message">
        <b>Informe o login do usuário!</b> <br />
        Um e-mail com as instruções para recuperação de senha será enviado para
        você.
      </PmwParagraph>
      <!-- FEEDBACK DE ERRO -->
      <div class="form-forgot-password--feedback">
        <PmwParagraph v-if="error" size="paragraph-40" fontSize="small">
          <span>{{ message }}</span>
        </PmwParagraph>
      </div>
      <!-- BOTÕES -->
      <div class="form-forgot-password--buttons">
        <PmwButton
          layout="outline"
          class="form-forgot-password--buttons__back"
          @click="toggleForgetPassword()"
        >
          Voltar
        </PmwButton>
        <PmwButton
          :disabled="loading"
          class="form-forgot-password--buttons__send"
          type="submit"
        >
          Enviar
        </PmwButton>
      </div>
    </form>
    <!-- TOKEN -->
    <form v-if="form.token" class="form-token" @submit="validateToken">
      <div class="form-token--box">
        <FormInput
          v-model="token"
          :class="{ 'form-error': error }"
          :maxlength="6"
          label="Token"
          type="text"
          placeholder="000000"
          class="form-token--input"
          ref="token"
          @input="formatToken"
        />
        <!-- FEEDBACK DE ERRO -->
        <div class="form-login--feedback">
          <PmwParagraph v-if="error" size="paragraph-40" fontSize="small">
            <span>{{ message }}</span>
          </PmwParagraph>
        </div>
        <!-- BOTÃO -->
        <PmwButton :disabled="loading" class="form-token--button" type="submit">
          Enviar
        </PmwButton>
      </div>
      <!-- INFO -->
      <div class="form-token--info">
        <template v-if="form.phone === null">
          <PmwParagraph class="form-token--message">
            Não recebeu seu token por e-mail? <br />
            <span class="link" @click="sendTokenPhone()">Clique aqui</span>
            e receba por SMS.
          </PmwParagraph>
        </template>
        <template v-if="form.phone === true">
          <Icon class="form-token--icon" icon="alert" />
          <PmwParagraph class="form-token--message form-token--message__left">
            Token enviado! Verifique seu celular e preencha acima o código
            recebido.
          </PmwParagraph>
        </template>
        <template v-if="form.phone === false">
          <Icon class="form-token--icon form-token--icon__error" icon="alert" />
          <PmwParagraph class="form-token--message form-token--message__left">
            Seu usuário não tem telefone cadastrado. Entre em contato com o
            administrador do sistema.
          </PmwParagraph>
        </template>
      </div>
    </form>
    <!-- SUCESSO  -->
    <div v-if="form.success" class="form-success">
      <PmwParagraph
        size="paragraph-80"
        weight="500"
        class="form-success--title"
        level="2"
        >Sucesso!</PmwParagraph
      >
      <!-- MENSAGEM -->
      <PmwParagraph class="form-success--message">
        {{ message }}
      </PmwParagraph>
      <Icon class="form-success--icon" icon="check" />
    </div>
  </BaseLayoutLogin>
</template>

<script>
import {
  setCurrentUserAccess,
  setCurrentTokenAccess,
  deleteCookie,
  getTokenCookieName,
  getCurrentTokenAccess
} from '@/helpers/auth'
import BaseLayoutLogin from '@/layouts/BaseLayoutLogin'
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import Icon from '@solucoes/components-lib-tmp/src/components/elements/Icon'
import debounce from 'lodash.debounce'
import { mapActions } from 'vuex'

import { formatDate } from '@/helpers/date'
import { setCookie } from '@/helpers/auth'

export default {
  name: 'Login',
  components: {
    BaseLayoutLogin,
    FormInput,
    PmwParagraph,
    PmwButton,
    Icon
  },
  data() {
    return {
      form: {
        /** Tela de login */
        login: true,
        /** Tela de "Esqueceu a senha" */
        forgotPassword: false,
        /** Tela de para inserir o Token */
        token: false,
        /** Enviar token por telefone */
        phone: null,
        /** Tela de sucesso */
        success: false
      },
      /** Informações de login */
      user: null,
      password: null,
      token: null,
      authCode: null,
      accessToken: null,
      refreshToken: null,
      redirect: '/Admin/v2/',
      /** Se houver erro em um dos formularios */
      error: false,
      /** Mensagem de retorno */
      message: null,
      /** Se o formulário está carregando */
      loading: false,
      /** Data e hora de expiração do token de 6 digitos */
      expirationDate: null,
      /** Data e hora de expiração do token de 6 refresh */
      jwtTokenExp: null,
      /** Configuração SSO por cliente */
      sso: {
        microsoft: {
          enabled: false,
          clientId: null,
          tenantId: null
        }
      }
    }
  },
  async created() {
    await this.fetchSsoConfig()
  },
  methods: {
    ...mapActions(['setAuthToken']),
    ...mapActions('user', ['setUserData']),

    /** Buscar configuração SSO do cliente */
    async fetchSsoConfig() {
      try {
        const { data } = await this.$auth.getSsoConfig()
        if (data.microsoft?.enabled) {
          this.sso.microsoft = data.microsoft
        }
      } catch {
        /** SSO indisponível, mantém desabilitado */
      }
    },

    /** Login SSO via Microsoft */
    async loginSSO() {
      this.loading = true
      this.clearErrors()

      try {
        const { initMsal, loginWithMicrosoft } = await import('@/helpers/msal')
        await initMsal(this.sso.microsoft.clientId, this.sso.microsoft.tenantId)
        const idToken = await loginWithMicrosoft()

        const response = await this.$auth.loginSSO({
          token: idToken,
          provider: 'Microsoft'
        })

        if (response.data.authenticated) {
          const isCentral =
            response.data.home.search(/^\/reserva\/central\/.*/) > -1

          setCookie('PMW-USER-DATA', response.data, {
            expires: new Date(response.data.validadeToken2FA)
          })

          this.setUserData(response.data)
          this.redirect = isCentral
            ? response.data.home
            : response.data.home
            ? `/admin/${response.data.home}`
            : this.redirect

          this.form.login = false
          this.form.success = true
          this.message = 'Estamos fazendo o seu login.'

          this.setAuthenticate(idToken, isCentral)
        } else {
          this.message = response.data.errors?.[0]?.message || null
          this.error = true
        }
      } catch (e) {
        const cancelled =
          e?.errorCode === 'user_cancelled' ||
          e?.errorCode === 'popup_window_error'

        if (!cancelled) {
          this.message =
            e?.response?.data?.errors?.[0]?.message ||
            'Erro ao autenticar com Microsoft.'
          this.error = true
        }
      } finally {
        this.loading = false
      }
    },

    /** Login
     * @param {Event} e - Capturar evento do formulário de login
     */
    async login(e) {
      /** Carregando loading */
      this.loading = true

      e.preventDefault()
      this.clearErrors()
      await this.$auth
        .login({
          login: this.user,
          senha: this.password
        })
        .then((response) => {
          if (response.data.sucesso) {
            this.expirationDate = response.data.validadeToken2FA
            this.authCode = response.data.authCode
            /** Verificar se há um cookie do token de 6 dígitos */
            if (getCurrentTokenAccess() !== undefined) {
              this.validateCurrentToken(getCurrentTokenAccess())
            } else {
              this.form.login = false
              this.form.token = true
              this.loading = false
            }
          } else {
            /** Exibir mensagem de erro retornada pelo back quando disponível */
            this.message = response.data.erros?.[0]?.message || null
            this.error = true
            this.loading = false
          }
        })
        .catch((e) => {
          this.message = e.response?.data?.erros?.[0]?.message || null
          this.error = true
          this.loading = false
        })
    },

    /** Enviar e-mail para redefinição de senha
     * @param {Event} e - Capturar evento do formulário de redefinição de senha
     */
    async forgotPassword(e) {
      /** Carregando loading */
      this.loading = true

      e.preventDefault()
      this.clearErrors()
      await this.$auth
        .forgotPassword({
          login: this.user
        })
        .then((response) => {
          if (response.data.sucesso) {
            this.form.forgotPassword = false
            this.form.success = true
            this.message =
              'O e-mail com as instruções para redefinição foi enviado com sucesso.'
          } else {
            this.error = true
          }
        })
        .catch((e) => {
          this.message = e.response.data.erros[0].message
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Validar token enviado por e-mail
     * @param {Event} e - Capturar evento do formulário de validação do token de seis dígitos
     */
    async validateToken(e) {
      /** Carregando loading */
      this.loading = true

      e.preventDefault()
      this.clearErrors()
      await this.$auth
        .validateEmailToken({
          login: this.user,
          authCode: this.authCode,
          token: this.token
        })
        .then((response) => {
          if (response.data.authenticated) {
            const isCentral =
              response.data.home.search(/^\/reserva\/central\/.*/) > -1

            setCookie('PMW-USER-DATA', response.data, {
              expires: new Date(response.data)
            })

            this.setUserData(response.data)

            /** Se central de reservas */
            if (isCentral) {
              this.redirect = response.data.home
            } else {
              this.redirect = response.data.home
                ? `/admin/${response.data.home}`
                : this.redirect
            }

            this.form.token = false
            this.form.success = true
            this.message = 'Estamos fazendo o seu login.'

            this.setAuthenticate(this.token, isCentral)
          } else {
            this.error = true
          }
        })
        .catch((e) => {
          this.message = e.response.data.errors[0].message
          this.error = true

          /** Apagar cookie do token de 6 dígitos */
          deleteCookie(getTokenCookieName())
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Validar token guardado em cookie
     * @param {String} token - Token de seis dígitos guardando em cookie
     */
    async validateCurrentToken(token) {
      /** Carregando loading */
      this.loading = true

      await this.$auth
        .validateEmailToken({
          login: this.user,
          authCode: this.authCode,
          token: token
        })
        .then((response) => {
          if (response.data.authenticated) {
            const isCentral =
              response.data.home.search(/^\/reserva\/central\/.*/) > -1

            setCookie('PMW-USER-DATA', response.data, {
              expires: new Date(response.data.validadeToken2FA)
            })

            this.setUserData(response.data)

            if (isCentral) {
              this.redirect = response.data.home
            } else {
              this.redirect = response.data.home
                ? `/admin/${response.data.home}`
                : this.redirect
            }

            /** Enviar para autenticação */
            this.setAuthenticate(token, isCentral)
          }
        })
        .catch(() => {
          /** Abrir formulário de token */
          this.form.login = false
          this.form.token = true

          /** Apagar cookie do token de 6 dígitos */
          deleteCookie(getTokenCookieName())
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * Autenticar usuário e redirecionar para a Tela inicial
     * @param {String} token - Token de seis dígitos
     * @param {Boolean} isCentral - Se a tela de home é central de reservas
     */
    setAuthenticate(token, isCentral) {
      /** Limpa informação do homepage */
      localStorage.removeItem('homePage')

      /** Guardar token de acesso */
      setCurrentUserAccess(this.accessToken, this.jwtTokenExp)
      this.setAuthToken(this.accessToken)

      /** Guardar token de 6 dígitos */
      setCurrentTokenAccess(token, this.expirationDate)

      /** Salva local inicial */
      localStorage.setItem('homePage', this.redirect)

      /** Redirecionar */
      if (isCentral) {
        window.open(this.redirect, '_blank')
      } else {
        this.$router.push(this.redirect.replace(this.$router.options.base, ''))
      }
    },

    /** Enviar token pelo celular */
    async sendTokenPhone() {
      /** Carregando loading */
      this.loading = true

      await this.$auth
        .sendSms({
          login: this.user,
          authCode: this.authCode
        })
        .then((response) => {
          if (response.data.sucesso) {
            this.form.phone = true
          } else {
            this.form.phone = false
          }
        })
        .catch(() => {
          this.form.phone = false
        })
        .finally(() => {
          this.loading = false
        })
    },

    /** Abrir/Fechar formulário de troca de senha */
    toggleForgetPassword() {
      this.form.forgotPassword = !this.form.forgotPassword
      this.form.login = !this.form.login
      this.clearErrors()
    },

    /** Limpar erros */
    clearErrors() {
      this.error = false
      this.message = ''
    },

    /** Criar o horário de expiração */
    generateExpirationTime() {
      const now = new Date()
      const expirationDateTime = now.setHours(now.getHours() + 3)

      return formatDate(expirationDateTime, 'yyyy-MM-dd HH:mm:ss')
    },

    /** Validar apenas numeros no Token */
    formatToken: debounce(function() {
      this.token = this.token.replace(/[^0-9]+/g, '')
    }, 100)
  }
}
</script>

<style lang="scss" scoped>
.pmw-form-field ::v-deep {
  .input--clear {
    color: pmw-colors('primary-120');
  }
  .input--field:-webkit-autofill,
  .input--field:-webkit-autofill:hover,
  .input--field:-webkit-autofill:focus {
    box-shadow: 0 0 0px 1000px $pmw-white inset;
  }
}

.form-login {
  padding: 30px 30px 33px 30px;

  &--user {
    margin-bottom: 25px;
  }

  &--password {
    margin-bottom: 20px;
  }

  &--forgot-password {
    line-height: 18px;
    margin-bottom: 5px;
  }

  &--feedback {
    color: $error;
    margin-bottom: 8px;
    text-align: center;
    line-height: 1.4;
  }

  &--button {
    width: 160px;
    display: block;
    margin: 0px auto;
  }

  &--sso-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 16px auto 0;
    padding: 12px 16px;
    background: $pmw-white;
    border: 1px solid pmw-colors('grey-60');
    border-radius: 2px;
    font-size: 13px;
    font-weight: 600;
    color: pmw-colors('grey-80');
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: pmw-colors('grey-10');
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }

    &__icon {
      width: 19px;
      height: 19px;
    }
  }
}

.form-forgot-password {
  padding: 30px 30px 33px 30px;

  &--message {
    color: $gray-dark;
    margin-bottom: 25px;
    text-align: center;
    line-height: 14px;
    font-size: 11px;

    b {
      font-weight: 700;
    }
  }
  &--buttons {
    display: flex;
    align-items: center;
    gap: 10px;

    &__back {
      ::v-deep button.button__fill {
        background: $pmw-white;
        color: $blue;
        border: 1px solid $blue;
      }
    }
  }
  &--feedback {
    color: $error;
    margin-top: 0px;
    margin-bottom: 15px;
    text-align: center;
    height: 18px;
  }
}

.form-token {
  &--box {
    padding: 30px 30px 0px 30px;
  }
  &--input {
    margin-bottom: 30px;
  }
  &--button {
    max-width: 160px;
    display: block;
    margin: 0px auto 40px auto;
  }
  &--info {
    padding: 22px 27px 20px 27px;
    background: #eeeeee;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    p {
      color: $gray-darkest;
      line-height: 21px;
    }
  }
  &--icon {
    color: $blue;
    min-width: 21px;
    width: 21px;
    height: 21px;
    flex: none;

    &__error {
      color: $error;
    }
  }
  &--message {
    text-align: center;

    &__left {
      text-align: left;
    }
  }
}

.form-success {
  padding: 30px;

  &--title {
    text-align: center;
    color: $gray-darkest;
    font-weight: 500;
    margin-bottom: 5px;
  }
  &--message {
    text-align: center;
    margin-bottom: 17px;
    color: $gray-darkest;
    line-height: 21px;
  }
  &--icon {
    background: pmw-colors('primary-120');
    border-radius: 100%;
    color: $pmw-white;
    width: 34px;
    height: 34px;
    padding: 10px;
    display: block;
    margin: 0px auto;
  }
}

.form-error ::v-deep input {
  border-bottom-color: pmw-colors('error-100');
  border-bottom-width: 2px;
}

.link {
  color: pmw-colors('primary-120');
  font-weight: 500;
  cursor: pointer;
}
</style>
